import PinIconHover from './component'

export default PinIconHover
